import { Container, SceneObject, SoundSceneObject } from '@cgs/wge';
import { ResourcesComponent } from '../../../game/components/resources_component';
import { SOUND_STORE_TOKEN, SoundStore, SoundStoreState } from '../../../store';
import { RESOURCES_COMPONENT_TOKEN } from '../../../type_definitions';

export const SOUND_VOLUME_CONTROLLER_TOKEN = Symbol('SoundVolumeController');

const BACKGROUND_PARENT_IDS = new Set(['background', 'background_fs', 'background_spin']);

export class SoundVolumeControllerComponent {
  private readonly soundStore: SoundStore;
  private readonly soundObjects: Set<SoundSceneObject> = new Set();

  constructor(container: Container) {
    this.soundStore = container.resolve<SoundStore>(SOUND_STORE_TOKEN);

    const resourceComponent = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    const allSounds = resourceComponent.root.findAllByType(SoundSceneObject);

    for (const sound of allSounds) {
      this.soundObjects.add(sound);
    }

    SceneObject.initialized
      .filter((scene) => scene instanceof SoundSceneObject)
      .on((scene) => {
        this.soundObjects.add(scene as SoundSceneObject);
        this.applySoundState(this.soundStore.state, scene as SoundSceneObject);
      });

    this.soundStore.stream.on((state) => this.updateSounds(state));
    this.updateSounds(this.soundStore.state);
  }

  private updateSounds(state: SoundStoreState): void {
    for (const sound of this.soundObjects) {
      this.applySoundState(state, sound);
    }
  }

  private applySoundState(state: SoundStoreState, sound: SoundSceneObject): void {
    const parentId = sound.parent?.id;

    if (parentId && BACKGROUND_PARENT_IDS.has(parentId)) {
      sound.muted = !state.backgroundMusic;
    } else {
      sound.muted = !state.soundFX;
    }
  }
}
